import { OperatorDescription } from '@v2/components/controls/FilterManager/types';

export const Operators = {
  LT: { operator: 'LT', label: 'Less than' },
  LTE: { operator: 'LTE', label: 'Less than or equal' },
  GT: { operator: 'GT', label: 'Greater than' },
  GTE: { operator: 'GTE', label: 'Greater than or equal' },
  EQ: { operator: 'EQ', label: 'Equal' },
  NEQ: { operator: 'NEQ', label: 'Not equal' },
  BETWEEN: { operator: 'BETWEEN', label: 'Between' },
  IN: { operator: 'IN', label: 'Is in' },
  NOT_IN: { operator: 'NOT_IN', label: 'Is not in' },
  HAS_PROPERTY: { operator: 'HAS_PROPERTY', label: 'Has a value for property' },
  NOT_HAS_PROPERTY: { operator: 'NOT_HAS_PROPERTY', label: "Doesn't have a value for property" },
  CONTAINS_TOKEN: { operator: 'CONTAINS_TOKEN', label: 'Contains a token' },
  NOT_CONTAINS_TOKEN: { operator: 'NOT_CONTAINS_TOKEN', label: "Doesn't contains a token" }
}

const TypeOperatorsMap: Record<string, OperatorDescription[]> = {
  'string': [
    Operators.EQ,
    Operators.NEQ,
    Operators.CONTAINS_TOKEN,
    Operators.NOT_CONTAINS_TOKEN,
    Operators.IN,
    Operators.NOT_IN,
  ],
  'number': [
    Operators.LT,
    Operators.LTE,
    Operators.GT,
    Operators.GTE,
    Operators.EQ,
    Operators.NEQ,
    Operators.BETWEEN,
  ],
  'date': [
    Operators.LT,
    Operators.LTE,
    Operators.GT,
    Operators.GTE,
    Operators.EQ,
    Operators.NEQ,
    Operators.BETWEEN,
  ],
  'datetime': [
    Operators.LT,
    Operators.LTE,
    Operators.GT,
    Operators.GTE,
    Operators.EQ,
    Operators.NEQ,
    Operators.BETWEEN,
  ],
  'enumeration': [
    Operators.EQ,
    Operators.NEQ,
    Operators.IN,
    Operators.NOT_IN,
  ],
  'bool': [
    Operators.EQ,
    Operators.NEQ,
  ]
}

export const getOperatorsForType = (type: string): OperatorDescription[] => {
  const typeOperators = TypeOperatorsMap[type];
  return typeOperators ? typeOperators : [];
}
